import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import NthBrandSelector from 'selectors/page/nthBrand/nthBrandSelector';
import { isStoreIdAndZipCodeReadySelector } from 'viewModel/selectors/user/isStoreIdAndZipCodeReadySelector';
import { isAnonymousSelector } from 'selectors/auth/isAnonymousSelector';
import catalogActions from 'actions/CatalogActions';
import categoryActions from 'actions/CategoryActions';
import userActions from 'actions/UserActions';
import { showUpdateDefaultSortSelector } from 'viewModel/selectors/testTarget/showUpdateDefaultSortSelector';
import { enabledSelector } from 'selectors/testTarget/offers/persistFiltersOnBrand/enabled/enabledSelector';
import { activeOptimizeShippingCopyPLPSelector } from 'viewModel/selectors/testTarget/activeOptimizeShippingCopyPLPSelector';
import { showSimplifyFiltersOnPLPSelector } from 'viewModel/selectors/testTarget/showSimplifyFiltersOnPLPSelector';

const { nthBrandSelector } = NthBrandSelector;

export default connect(
    createStructuredSelector({
        catalog: nthBrandSelector,
        isStoreIdAndZipCodeReady: isStoreIdAndZipCodeReadySelector,
        isAnonymous: isAnonymousSelector,
        showUpdateDefaultSort: showUpdateDefaultSortSelector,
        persistFiltersOnBrand: enabledSelector,
        isOptimizeShippingCopyPLPActive: activeOptimizeShippingCopyPLPSelector,
        showSimplifyFiltersOnPLP: showSimplifyFiltersOnPLPSelector
    }),
    {
        applyFilters: catalogActions.applyFilters,
        validateUpperFunnelParams: categoryActions.validateUpperFunnelParams,
        getFulfillmentOptions: categoryActions.getFulfillmentOptions,
        onStoreChangedFromHeader: userActions.onStoreChangedFromHeader,
        onZipCodeChangedFromHeader: userActions.onZipCodeChangedFromHeader,
        dispatchMarketingParams: catalogActions.dispatchMarketingParams
    }
);
